import useFirebase from "../../../../../useFirebase";

function useGallery(device, allFireStoreData) {
  const { getCollectionData, postCollectionData, createCollectionData } =
    useFirebase();

  function callFireStoreForEnableDisable(payload) {
    const payload1 = {
      gallerysupervision: {
        syncGalleryImageAndVideo: payload?.galleryEnabled == 1 ? true : false,
      },
    };
    const payload2 = {
      setRulesActiveInActiveStatus: {
        ...allFireStoreData.setRulesActiveInActiveStatus,
        galleryMonitoringEnabled: payload?.galleryEnabled == 1 ? true : false,
      },
    };
    // console.log(payload1, payload2);
    postCollectionData(device, payload1);

    postCollectionData(device, payload2);
    getCollectionData(device);
  }

  function handleToggleChange(name, checked) {
    // const { name, checked } = e.target;
    const collectionPayload = {};

    if (name === "GALLERY_ENABLE") {
      collectionPayload["galleryEnabled"] = checked ? 1 : 0;
    }

    callFireStoreForEnableDisable(collectionPayload);
  }

  return {
    handleToggleChange,
  };
}

export default useGallery;
